import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Tabs, Tab } from 'material-ui/Tabs';
import LdapServerSettingsForm from '../forms/ldapServerSettingsForm';
import LdapSchemaForm from '../forms/ldapSchemaForm';
import LdapSynchronizationForm from '../forms/ldapSynchronizationForm';

@inject('translationsStore') @observer
export default class LdapEditTabs extends Component {

    state = {
        selectedTabId: this.props.selectedTabId ? this.props.selectedTabId : 1
    };

    handleActive = (tab) => {

        this.setState({
            selectedTabId: tab.props['value']
        });

        this.props.onClick(tab.props['value']);
    }

    render() {

        const tabStyleProps = {
            className: `tab-dialog`,
            buttonStyle: { color: '#372f51' },
            style: {backgroundColor: '#fff'}
        };

        const tabs = [{
                id: 1,
                title: this.props.translationsStore.translate('SERVER_SETTINGS'),
                component: <LdapServerSettingsForm currentLdapStore={this.props.currentLdapStore} />,
                icon: null,
                dataCy: 'server-settings-tab'
            },
            {
                id: 2,
                title: this.props.translationsStore.translate('DIRECTORY_SETTINGS'),
                component: <LdapSchemaForm currentLdapStore={this.props.currentLdapStore} />,
                icon: null,
                dataCy: 'directory-settings-tab'
            },
            {
                id: 3,
                title: this.props.translationsStore.translate('SYNCHRONIZATION'),
                component: <LdapSynchronizationForm currentLdapStore={this.props.currentLdapStore} />,
                icon: null,
                dataCy: 'synchronization-tab'
            }
        ];

        return(
            <div>
                <Tabs className='tabs-dialog' contentContainerClassName='tabs-dialog-content-wrapper'>
                    {
                        tabs.map((tab, index) => {
                            
                            return <Tab key={tab.id} {...tabStyleProps} 
                                        value={tab.id}
                                        className={`tab-dialog${this.state.selectedTabId == tab.id ? 
                                            ' selected' : ''}`}
                                        style={{backgroundColor: '#fff'}} 
                                        label={tab.title}
                                        onActive={this.handleActive}
                                        data-cy={tab.dataCy}>
                                    </Tab>

                        })
                    }
                </Tabs>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/ldapEditTabs/index.jsx